import { t } from "@lingui/macro";
import {StorageKey} from "../../../../enums/StorageKey";

export default {
    storageKey: StorageKey.report_inventory_summary,
    getReportLabel: () => t`Inventory Summary`,
    getColumns: () => [],
};
